export default __webpack_public_path__ + "static/media/26362-danamekai.366c0208.pdf";